// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"8e52e5a2","124":"30023611","146":"a8b42af1","363":"46a9bb47","397":"b6368dcc","424":"b7b432c2","493":"775349aa","658":"ac995fe7","895":"afca0e7c","896":"6a8a455b","942":"93289c9a"}[chunkId] + ".chunk.js";
};